import React from 'react';
import Image from '../../../image/Image';
import './NameWithIcon.scss';

const NameWithIcon = ({
    icon,
    name,
    link,
}: {
    icon: string,
    name: string,
    link?: string,
}) => {
    const onNameClick = () => {
        if (link) {
            window.open(link, '_blank');
        }
    };

    return (
        <div className="nameWithIcon">
            {icon && (
                <Image src={icon} alt={name} className="nameWithIcon_icon"/>
            )}
            <span title={link ?? name} className={link ? 'is-link' : ''} onClick={onNameClick}>{name}</span>
        </div>
    );
};

export default NameWithIcon;